import "./CloudAccountingPage2.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import KeyBenefits from "./sections/KeyBenefits";
import HowItWorks from "./sections/HowItWorks";
import PricingPlans from "./sections/PricingPlans";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import GetStarted from "./sections/GetStarted";
import Footer from "@/reusable_sections/Footer";
export default function CloudAccountingPage2() {
  return <div>
      <Header />
      <Hero />
      <KeyBenefits />
      <HowItWorks />
      <PricingPlans />
      <FrequentlyAskedQuestions />
      <GetStarted />
      <Footer />
    </div>;
}